<template>
  <div v-if="computedEvents" id="eventPrintPanel">
    <section-header
      id="events"
      :departmentId="departmentId"
      :swiftMove="swiftMove"
      >Events ({{ computedEvents.length }})</section-header
    >
    <a class="events--printbutton" @click="print">download</a>
    <!-- eventsBean.downloadAll -->
    <div class="events">
      <div
        v-for="(event, current) in computedEvents"
        :key="current"
        class="event"
      >
        <img
          :src="`https://api.conveyancingtracker.com/nocors/open/images/events/${event.image}`"
          class="event--logo"
          :alt="event.name"
          v-if="event.image"
          :title="`id:${event.id}`"
        />
        <div class="event--info">
          <span style="font-weight: bold; font-size: 1.1em">{{
            event.name
          }}</span>
          <div>
            <span style="color: gray">{{
              event.timestamp | formatDateTime
            }}</span>
            -
            <EntityZ :entity="event.user" format="system" v-if="event.user" />
          </div>
          <div :class="event.subType == 'note' ? 'eventPreWrap' : null">
            <div v-html="event.info" />
            <div class="event--uploadedit" v-if="event.subType === 'upload'">
              <router-link
                :to="{ name: 'uploadFile', params: { id: event.id } }"
                >Edit</router-link
              >
            </div>
          </div>
          <div>
            <Status
              :event="event"
              @hideNote="hideNote"
              @hideUpload="hideUpload"
              @dealtNote="dealtNote"
              @dealtEmail="dealtEmail"
            />
          </div>
        </div>
        <Buttons
          :event="event"
          :printer="printer"
          @delete="deleteEventWrapper"
        />
      </div>
    </div>
    <v-btn
      class="events--addbutton"
      v-if="!addEventStatus"
      @click="addEventStatus = 1"
    >
      <v-icon>add</v-icon>Event
    </v-btn>
    <div v-if="addEventStatus" class="ajaxForm">
      <template v-if="addEventStatus == 1">
        <h2>Choose type of event you wish to add</h2>
        <ul>
          <li>
            <router-link
              :to="{
                name: 'documentEntityType',
                params: { objectType: 'file', objectId: $route.params.id }
              }"
              >Document</router-link
            >- Please choose who you want to write to
          </li>
          <li>
            <a @click="addEventStatus = 3">Event</a> - add a simple event to
            alert the client of progress
          </li>
          <li>
            <a @click="addEventStatus = 4">Note</a> - add a file note. this can
            be visible to the client
          </li>
          <li>
            <router-link
              :to="{ name: 'satisfaction', params: { id: $route.params.id } }"
              >Satisfaction survey</router-link
            >- email a satisfaction survey to the clients on this matter
          </li>
          <li>
            <router-link
              :to="{
                name: 'scanners',
                query: { objectType: 'file', objectId: $route.params.id }
              }"
              >Scan</router-link
            >- add a scan already uploaded to autolaw from your local scanner
          </li>
          <li>
            <router-link
              :to="{
                name: 'uploadCommon',
                params: { objectType: 'file', objectId: $route.params.id }
              }"
              >Scan common</router-link
            >- add a commonly used scan
          </li>
          <li>
            <router-link
              :to="{
                name: 'upload',
                query: { objectType: 'file', objectId: $route.params.id }
              }"
              >Upload</router-link
            >- upload a file from your local machine or network
          </li>
        </ul>
      </template>
      <Event v-if="addEventStatus == 3" @create="createEvent" />
      <Note
        v-if="addEventStatus == 4"
        :related="related"
        @create="createNote"
      />
      <hr />
      <div style="text-align: right">
        <v-btn @click="addEventStatus = 0">Cancel</v-btn>
      </div>
    </div>
    <v-snackbar :value="eventSnackbar" :multi-line="true" :top="true">
      {{ eventSnackbar }}
      <v-btn color="pink" flat @click="eventSnackbar = null">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import FILE_DOCUMENTS from "@/graphql/file/FileDocuments";
import FILE_EMAILS from "@/graphql/file/FileEmails";
import FILE_EVENTS from "@/graphql/file/FileEvents";
import FILE_NOTES from "@/graphql/file/FileNotes";
import FILE_UPLOAD_FILES from "@/graphql/file/FileUploadFiles";
import UPDATE_FILE_NOTE_HIDE from "@/graphql/file/UpdateFileNoteHide";
import UPDATE_FILE_UPLOADFILE_HIDE from "@/graphql/file/UpdateFileUploadFileHide";
import UPDATE_FILE_NOTE_DEALT from "@/graphql/file/UpdateFileNoteDealt";
import DELETE_EVENT from "@/graphql/file/DeleteEvent";
import DELETE_NOTE from "@/graphql/file/DeleteNote";
import DELETE_DOCUMENT from "@/graphql/document/DeleteDocument";
import DELETE_UPLOADFILE from "@/graphql/document/DeleteUploadFile";
import DELETE_EMAIL from "@/graphql/email/DeleteEmail";
import CREATE_FILE_NOTE from "@/graphql/file/CreateFileNote";
import CREATE_FILE_EVENT from "@/graphql/file/CreateFileEvent";
import EntityZ from "@/components/link/EntityZ";
import Buttons from "@/components/file/events/Buttons";
import Event from "@/components/file/events/Event";
import Note from "@/components/file/events/Note";
import SectionHeader from "@/components/file/SectionHeader";
import Status from "@/components/file/events/Status";
import { printElement } from "@/util/helpers";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Events",
  apollo: {
    documents: {
      query: FILE_DOCUMENTS,
      variables() {
        return {
          id: Number(this.$route.params.id)
        };
      },
      update: (data) => data.file.documents,
      fetchPolicy: "cache-and-network"
    },
    emails: {
      query: FILE_EMAILS,
      variables() {
        return {
          id: Number(this.$route.params.id)
        };
      },
      update: (data) => data.file.emails,
      fetchPolicy: "cache-and-network"
    },
    events: {
      query: FILE_EVENTS,
      variables() {
        return {
          id: Number(this.$route.params.id)
        };
      },
      update: (data) => data.file.events,
      fetchPolicy: "cache-and-network"
    },
    notes: {
      query: FILE_NOTES,
      variables() {
        return {
          id: Number(this.$route.params.id)
        };
      },
      update: (data) => data.file.notes,
      fetchPolicy: "cache-and-network"
    },
    uploadFiles: {
      query: FILE_UPLOAD_FILES,
      variables() {
        return {
          id: Number(this.$route.params.id)
        };
      },
      update: (data) => data.file.uploadFiles,
      fetchPolicy: "cache-and-network"
    }
  },
  components: {
    EntityZ,
    Buttons,
    Event,
    Note,
    SectionHeader,
    Status
  },
  props: ["departmentId", "swiftMove"],
  computed: {
    computedEvents() {
      const array = [];
      this.documents &&
        this.documents.forEach((d) => {
          const template = d.templateRevision.snippet.template;
          const roles = template ? template.roles.map((r) => r.name) : [];
          const hidden = !roles.includes("client");
          const clientDownload =
            d.entities && d.entities.length
              ? [3, 4].includes(d.entities[0].type.id)
              : undefined;
          const document = {
            type: "document",
            path: `document-${d.id}-0.pdf`,
            pathCopy: `document-${d.id}-1.pdf`
          };
          array.push({
            id: d.id,
            eventTypeId: template ? template.id : undefined,
            dealt: 3,
            subType: "document",
            eventType: null,
            user: d.user,
            name: template ? template.name : undefined,
            info: template ? template.blurb : undefined,
            image: template ? template.image : undefined,
            extra: null,
            timestamp: d.customdate ? d.customdate : d.timestamp,
            hidden,
            document,
            clientDownload
          });
        });
      this.emails &&
        this.emails.map((e) => {
          array.push({
            id: e.id,
            eventTypeId: 0,
            dealt: e.dealt ? 1 : 0,
            subType: "email",
            eventType: null,
            user: e.user,
            name: "Email",
            info: e.subject,
            image: "note.jpg",
            extra: null,
            timestamp: e.sent,
            hidden: e.hide
          });
        });
      this.events &&
        this.events.forEach((e) => {
          array.push({
            id: e.id,
            eventTypeId: e.eventType.id,
            dealt: 2,
            subType: "event",
            eventType: e.eventType,
            user: e.user,
            name: e.eventType ? e.eventType.name : undefined,
            info: e.eventType ? e.eventType.help : undefined,
            image: e.eventType ? e.eventType.image : undefined,
            extra: null,
            timestamp: e.customdate ? e.customdate : e.timestamp,
            hidden: false
          });
        });
      this.notes &&
        this.notes.forEach((n) => {
          const document = { type: "note", path: `note-${n.id}-1.pdf` };
          array.push({
            id: n.id,
            eventTypeId: 0,
            dealt: n.dealt ? 1 : 0,
            subType: "note",
            eventType: null,
            user: n.user,
            name: "Note",
            info: n.body,
            image: "note.jpg",
            extra: null,
            timestamp: n.timestamp,
            hidden: n.hide,
            document
          });
        });
      this.uploadFiles &&
        this.uploadFiles.forEach((u) => {
          const extra = u.upload.type;
          const document =
            u.upload.virus == 2
              ? {
                  type: "upload",
                  path: `upload/upload-${u.id}-0.${extra}`,
                  clientDownload: true
                }
              : undefined;
          array.push({
            id: u.id,
            eventTypeId: u.upload.virus,
            dealt: 4,
            subType: "upload",
            eventType: null,
            user: u.user,
            name: "Upload",
            info: u.uploadDescription
              ? u.uploadDescription.body
              : "Uploaded document",
            image: "cloud.jpg",
            extra,
            timestamp: u.timestamp,
            hidden: u.hide,
            document
          });
        });
      array.sort(function (a, b) {
        return new Date(a.timestamp) - new Date(b.timestamp);
      });
      return array;
    }
  },
  data() {
    return {
      addEventStatus: null,
      eventSnackbar: null,
      printer: null
    };
  },
  methods: {
    async fetchPrinter() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/entities/current/printer`
      );
      // console.log(response.data);
      this.printer = response.data;
    },
    updated(value) {
      this.update();
      this.eventSnackbar = value;
    },
    sortTimestamp(a, b) {
      return new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime();
    },
    print() {
      printElement("eventPrintPanel");
    },
    async hideNote(variables) {
      await this.$apollo.mutate({
        mutation: UPDATE_FILE_NOTE_HIDE,
        variables,
        refetchQueries: [
          {
            query: FILE_NOTES,
            variables: { id: Number(this.$route.params.id) }
          }
        ]
      });
      this.eventSnackbar = `Note hide ${variables.value}`;
    },
    async hideUpload(variables) {
      await this.$apollo.mutate({
        mutation: UPDATE_FILE_UPLOADFILE_HIDE,
        variables,
        refetchQueries: [
          {
            query: FILE_UPLOAD_FILES,
            variables: { id: Number(this.$route.params.id) }
          }
        ]
      });
      this.eventSnackbar = `Upload hide ${variables.value}`;
    },
    async dealtNote(variables) {
      await this.$apollo.mutate({
        mutation: UPDATE_FILE_NOTE_DEALT,
        variables,
        refetchQueries: [
          {
            query: FILE_NOTES,
            variables: { id: Number(this.$route.params.id) }
          }
        ]
      });
      this.eventSnackbar = `Changes note ${variables.noteid} dealt -> ${variables.value}`;
    },
    async dealtEmail(dealt) {
      await nbmlaw.put(`/cors/admin/email/emails/${this.event.id}/dealt`, null);
      this.eventSnackbar = `Email dealt ${dealt}`;
    },
    deleteEventWrapper(event) {
      if (event.subType === "note") {
        this.deleteNote(event.id);
      } else if (event.subType === "event") {
        this.deleteEvent(event.id);
      } else if (event.subType === "document") {
        this.deleteDocument(event.id);
      } else if (event.subType === "upload") {
        this.deleteUploadFile(event.id);
      } else if (event.subType === "email") {
        this.deleteEmail(event.id);
      }
    },
    async deleteNote(id) {
      await this.$apollo.mutate({
        mutation: DELETE_NOTE,
        variables: { id },
        refetchQueries: [
          {
            query: FILE_NOTES,
            variables: { id: Number(this.$route.params.id) }
          }
        ]
      });
      this.eventSnackbar = `Note deleted`;
    },
    async deleteEvent(id) {
      await this.$apollo.mutate({
        mutation: DELETE_EVENT,
        variables: { id },
        refetchQueries: [
          {
            query: FILE_EVENTS,
            variables: { id: Number(this.$route.params.id) }
          }
        ]
      });
      this.eventSnackbar = `Event deleted`;
    },
    async deleteDocument(id) {
      await this.$apollo.mutate({
        mutation: DELETE_DOCUMENT,
        variables: { id },
        refetchQueries: [
          {
            query: FILE_DOCUMENTS,
            variables: { id: Number(this.$route.params.id) }
          }
        ]
      });
      this.eventSnackbar = `Document deleted`;
    },
    async deleteUploadFile(id) {
      await this.$apollo.mutate({
        mutation: DELETE_UPLOADFILE,
        variables: { id },
        refetchQueries: [
          {
            query: FILE_UPLOAD_FILES,
            variables: { id: Number(this.$route.params.id) }
          }
        ]
      });
      this.eventSnackbar = `Upload deleted`;
    },
    async deleteEmail(id) {
      await this.$apollo.mutate({
        mutation: DELETE_EMAIL,
        variables: { id },
        refetchQueries: [
          {
            query: FILE_EMAILS,
            variables: { id: Number(this.$route.params.id) }
          }
        ]
      });
      this.eventSnackbar = `Email deleted`;
    },
    async createNote(variables) {
      await this.$apollo.mutate({
        mutation: CREATE_FILE_NOTE,
        variables,
        refetchQueries: [
          {
            query: FILE_NOTES,
            variables: { id: Number(this.$route.params.id) }
          }
        ]
      });
      this.eventSnackbar = `Note created`;
      this.addEventStatus = null;
    },
    async createEvent(variables) {
      await this.$apollo.mutate({
        mutation: CREATE_FILE_EVENT,
        variables,
        refetchQueries: [
          {
            query: FILE_EVENTS,
            variables: { id: Number(this.$route.params.id) }
          }
        ]
      });
      this.eventSnackbar = `Event created`;
      this.addEventStatus = null;
    }
  },
  created() {
    this.fetchPrinter();
  }
};
</script>

<style lang="scss" scoped>
.events {
  display: flex;
  flex-direction: column;

  &--printbutton {
    @media print {
      display: none;
    }

    &--addbutton {
      @media print {
        display: none;
      }
    }
  }
}

.event {
  display: flex;
  flex-direction: row;
  padding: 1rem;

  &--uploadedit {
    @media print {
      display: none;
    }
  }

  &:nth-child(even) {
    background: #ddd;
  }

  &:nth-child(odd) {
    background: #fff;
  }

  &--logo {
    height: 45px;
    width: 45px;
    border: 1px solid gray;
    margin-right: 1rem;
  }

  &--info {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  &PreWrap {
    white-space: pre-wrap;
  }
}
</style>
